import AnnotationsProvider from './AnnotationsProvider';

export default class AnnotationsService {
  constructor({ target }) {
    this.target = target;
  }

  getAnnotationsByMotivation(motivation) {
    return AnnotationsProvider.getAnnotationsByMotivation(motivation, this.target.id);
  }

  getAnnotationById(motivation, annotationId) {
    return AnnotationsProvider.getAnnotationById(motivation, annotationId);
  }

  subscribeToAnnotationMotivation(motivation, callback) {
    return AnnotationsProvider.subscribeToAnnotationMotivation(motivation, this.target.id, callback);
  }

  setAnnotationBody(annotationId, body) {
    return AnnotationsProvider.setAnnotationBody(annotationId, body);
  }

  createAnnotation(motivation, body, subTarget) {
    return AnnotationsProvider.createAnnotation(motivation, body, this.target, subTarget);
  }

  static build(args) {
    return new AnnotationsService(args);
  }
}
